import { FunctionComponent as F, useState } from "react";
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Container from "../../components/UI/Container/Container";
import { Box, Link, Stack } from "@mui/material";
import PageHeadline from "../../components/UI/Text/PageHeadline";
import DeleteWarningDialog from "../../components/Account/DeleteWarningDialog";
import { logoutAsync } from "../../core/store/user/user.thunks";
import { useAppDispatch } from "../../core/store/hooks";
import { DELETE_ACCOUNT, LOGIN } from "../../core/router/paths";
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";
import DeleteIcon from '@mui/icons-material/Delete';
import Button from "../../components/UI/Button/Button";



const DeleteAccount: F = () =>
{
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const [deleteWarningDialog, setDeleteWarningDialog] = useState(false);
  const user = useSelector((state: IState) => state.user);

  const LoginLink = (text: string) =>
    <Link
      variant='body2'
      sx={{ cursor: 'pointer' }}
      onClick={() => appDispatch(logoutAsync())
        .then(() => navigate(LOGIN, { state: { redirectTo: DELETE_ACCOUNT } }))}>
      {text}
    </Link>;

  return (
    <Container>
      <Stack sx={{ pt: 10 }} direction='column' alignItems='left' spacing={2}>
        <PageHeadline>Delete Account</PageHeadline>
        {user.username ?
          <Typography variant='body2'>
            {"You are currently logged in as "}
            <Box fontWeight='bold' component="span">
              {user.username}
            </Box>
            {". "}
            <br/><br/>
          </Typography> :
          <Typography variant='body2'>
            {"You are not currently logged in. Please "}
            <Link
              variant='body2'
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate(LOGIN, { state: { redirectTo: DELETE_ACCOUNT } })}>
              {"log in with this link"}
            </Link>
            {" first and you will be redirected back here to delete your account."}
          </Typography>}
          <Typography variant='body2'>
            {"If you proceed, your account (including all protocols) will be permanently deleted. "}
            {"Database backups are taken once a month and retained for one month. "}
            {"After this, your data will be irrecoverable. "}
          </Typography>
        <Box sx={{ display: "flex" }}>
          {user.username ?
            <Button
              startIcon={<DeleteIcon />}
              onClick={() => setDeleteWarningDialog(true)}
              id='Delete'
              label='Delete account'
              size='medium'
              type='secondary'/> :
            <></>}
          <Box />
        </Box>
        <Box sx={{ height: 4 }}/>
        {user.username ?
          <Typography variant='body2'>
            {"Want to delete a different account? "}
            {LoginLink("Log in using this link")}
            {" and you will be redirected back here to delete it."}
          </Typography> :
          <></>}
      </Stack>
      {deleteWarningDialog ?
        <DeleteWarningDialog close={() => setDeleteWarningDialog(false)}/> :
        <></>}
    </Container>);
};

export default DeleteAccount;

